/**
 * Level 10: The Summit
 * 
 * Final level combining all mechanics:
 * - All mechanics present (trampolines, portals, wind, lava)
 * - Longest and most challenging level
 * - Vertical climb to the peak
 * - Ultimate speedrun challenge
 * 
 * @module configs/levels/Level10_TheSummit
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level10_TheSummit = {
    id: 10,
    name: 'The Summit',
    subtitle: 'Final Challenge',
    description: 'The ultimate test combining all mechanics.',
    
    worldWidth: 6000,
    worldHeight: 2200,
    playerStart: { x: 100, y: 2000 },
    
    theme: {
        bgGradient: ['#0a1628', '#1e3a5f'],
        platformColor: 0x4a6fa5,
        accentColor: 0x00ffff,
        particleColor: 0xffffff,
        ambient: 'summit'
    },
    
    platforms: [
        { x: 0, y: 2100, w: 500, h: 50 },
        { x: 600, y: 1950, w: 150, h: 25 },
        { x: 850, y: 1800, w: 150, h: 25 },
        { x: 1100, y: 1650, w: 200, h: 30 },
        { x: 1400, y: 1500, w: 350, h: 40 },
        { x: 1850, y: 1350, w: 120, h: 20 },
        { x: 2050, y: 1200, w: 120, h: 20 },
        { x: 2250, y: 1050, w: 120, h: 20 },
        { x: 2500, y: 900, w: 250, h: 30 },
        { x: 2850, y: 750, w: 150, h: 20 },
        { x: 3100, y: 600, w: 200, h: 25 },
        { x: 3400, y: 700, w: 100, h: 20 },
        { x: 3600, y: 800, w: 100, h: 20 },
        { x: 3800, y: 900, w: 150, h: 25 },
        { x: 4050, y: 750, w: 200, h: 30 },
        { x: 4350, y: 600, w: 150, h: 25 },
        { x: 4600, y: 450, w: 200, h: 30 },
        { x: 4900, y: 300, w: 400, h: 50 },
        { x: 5400, y: 500, w: 600, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 750, y: 1900, w: 80, h: 20, moveY: 100, speed: 0.004 },
        { x: 2150, y: 1100, w: 100, h: 20, moveX: 100, speed: 0.005 },
        { x: 3500, y: 750, w: 80, h: 15, moveY: 80, speed: 0.006 },
        { x: 4200, y: 680, w: 100, h: 20, moveX: 120, speed: 0.005 },
        { x: 5200, y: 400, w: 120, h: 20, moveY: 100, speed: 0.004 }
    ],
    
    spikes: [
        { x: 1500, y: 1500 },
        { x: 1550, y: 1500 },
        { x: 2550, y: 900 },
        { x: 2600, y: 900 },
        { x: 3150, y: 600 },
        { x: 4100, y: 750 },
        { x: 4650, y: 450 },
        { x: 5000, y: 300 },
        { x: 5500, y: 500 }
    ],
    
    stars: [
        { x: 850, y: 1700 },
        { x: 1100, y: 1550 },
        { x: 1600, y: 1400 },
        { x: 2250, y: 950 },
        { x: 2850, y: 650 },
        { x: 3600, y: 700 },
        { x: 4350, y: 500 },
        { x: 5100, y: 200 },
        { x: 5700, y: 400 }
    ],
    
    enemies: [
        { x: 1500, y: 1450 },
        { x: 2550, y: 850 },
        { x: 3150, y: 550 },
        { x: 3850, y: 850 },
        { x: 4700, y: 400 },
        { x: 5500, y: 450 }
    ],
    
    door: { x: 5800, y: 350, w: 50, h: 300 },
    button: { x: 5500, y: 495 },
    box: { x: 4950, y: 250, floating: true }, // MAGNETIC BOX
    goal: { x: 5900, y: 400 },
    
    trampolines: [
        { x: 1300, y: 1500, w: 70 },
        { x: 2400, y: 900, w: 60 },
        { x: 4850, y: 300, w: 70 }
    ],
    
    windZones: [
        { x: 2800, y: 500, w: 400, h: 300, direction: 'up', force: 0.002 }
    ],
    
    portals: [
        { x1: 500, y1: 2050, x2: 4150, y2: 700, color: 0x00ffff }
    ],
    
    lavaZones: [
        { x: 3200, y: 2150, w: 800, h: 50 }
    ],
    
    speedrunTargets: { gold: 75, silver: 100, bronze: 140 }
};

export default Level10_TheSummit;
